import { ArrowLongRightIcon } from '@heroicons/react/24/outline';

import { defaultCurrencyFormat } from 'src/common/defaultCurrencyFormat';
import { TripUpdateRead } from 'src/common/external/bambi-api/bambiApi';

import { DefaultChangeValueRenderer } from './DefaultChangeValueRenderer';

export function TripPriceInCentsChangeValue({
  tripEvent,
  valueKey,
}: {
  tripEvent: TripUpdateRead;
  valueKey: string;
}) {
  const old = defaultCurrencyFormat(
    String(tripEvent.values_changed?.[valueKey].old_value)
  );
  const newTime = defaultCurrencyFormat(
    String(tripEvent.values_changed?.[valueKey].new_value)
  );
  return (
    <div className="flex items-center gap-1">
      <DefaultChangeValueRenderer value={old} />
      <ArrowLongRightIcon className="h-5 w-5" />
      <DefaultChangeValueRenderer value={newTime} />
    </div>
  );
}
